import { useMemo } from 'react';

import { PieChart, PieChartProps } from '../../../renderers/pie-chart/pie-chart.component';
import { toApexPieSeries } from '../../../utils/to-apex-series';
import { EQUIPMENT_CERTIFICATIONS_DONUT_CHART_DEFINITION } from './equipment-certifications-donut-chart.definition';
import { EQUIPMENT_CERTIFICATIONS_DONUT_CHART_MOCK_DATA } from './equipment-certifications-donut-chart.mock';

const CERTIFICATION_COLORS = ['var(--color-brand-primary)', 'var(--color-brand-secondary)', 'var(--color-status-warning)'] as const;

export const EquipmentCertificationsDonutChart = (props: PieChartProps) => {
    const { series } = useMemo(() => toApexPieSeries(props.data), [props.data]);
    const total = series.reduce((sum, value) => sum + value, 0);

    return (
        <PieChart
            {...props}
            variant='donut'
            centerIcon={<span className='text-foreground-default flex size-full items-center justify-center text-2xl font-semibold'>{total}</span>}
            chartOptions={{
                colors: [...CERTIFICATION_COLORS],
                legend: {
                    show: true,
                    position: 'right',
                    horizontalAlign: 'center',
                    fontSize: '14px',
                    fontWeight: 500,
                    markers: {
                        size: 6,
                        offsetX: -2
                    },
                    itemMargin: {
                        vertical: 8
                    },
                    labels: {
                        colors: 'var(--color-foreground-default)'
                    },
                    formatter: (seriesName, opts) => `${seriesName}  ${opts.w.globals.series[opts.seriesIndex]}`
                },
                ...props.chartOptions
            }}
        />
    );
};

EquipmentCertificationsDonutChart.definition = EQUIPMENT_CERTIFICATIONS_DONUT_CHART_DEFINITION;
EquipmentCertificationsDonutChart.mockData = EQUIPMENT_CERTIFICATIONS_DONUT_CHART_MOCK_DATA;
